module.exports = __webpack_public_path__ + "static/media/header.9dabc3b5.png";